export const tool = {
  pageNext: "Next",
  pagePrevious: "Previous"
};
